var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _g9, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoS1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 554 419",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:#263271}.st7{fill:#913f29}.st11{fill:#513091}.st12{fill:#d89364}.st14{fill:#7249b2}.st15{fill:#b77344}.st16{fill:#fff}.st17{fill:#1e036b}.st23{fill:#08003c}.st24{fill:#a6a8ab}.st25{fill:#3a3942}.st29{fill:#ff375f}.st31{fill:#d6203f}.st32{fill:#808184}.st33{fill:#db7961}.st34{fill:#2e1370}.st37{fill:#39395c}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG_1_",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 199.545,
    x2: 554,
    y2: 199.545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7747ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fbff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.1 314.5c-56-31.2-97.2-124-27.3-160.4 42.3-22 116.4 6.8 149.4-8.8 34.6-16.3 38.7-57.7 57.4-87.7C265 23.5 307.8 1.1 353.9.1c46-1 99.4 16.1 128.4 49.1s32.8 80.9 18.4 118c-5.4 14.1-14.2 27.8-12.8 43 2.4 25.6 29.9 42.5 47.6 64.1 23.2 28.3 25.2 65.4 2.5 91.1-33.9 38.3-119 34.4-147.9 32.8-42.6-2.3-223.4-50.4-241.5-54.8-23-5.6-64-17.5-84.5-28.9z",
    fill: "url(#SVGID_1_)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Plants_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.104,
    y1: 320.737,
    x2: 161.289,
    y2: 320.737
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75e0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4add85"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93 321.4c10.1 2.7 16.7 11.9 19.1 15.9 1.3-5.4 2.9-10.6 4.5-15.4-16.4-2.2-14.9-21.6-14.9-21.6 10.6 6 14.5 14.7 15.8 19.1 2.2-6.1 4.5-11.6 6.8-16.5.3-.7.7-1.5 1-2.2-7.9 1.1-12.2-21.6-12.2-21.6 8.9 6.2 12.4 14.7 13.7 18.6 2.9-5.7 5.8-10.8 8.4-15.1-11.3-9-4.2-24.4-4.2-24.4 6.8 7.6 7.1 16 6.4 20.9 4.7-7.2 8.3-11.8 9.5-13.2.8-12.4 12.9-20.7 12.9-20.7 1 13.7-5.9 19.6-10 21.9-.1.1-.1.2-.2.3-.1.2-4.7 5.5-10.6 15 3.7-3 11.5-7.9 22.4-5.5 0 0-10.3 14.1-23.9 8-2.4 4-5 8.6-7.6 13.8 3.7-1.7 10.9-3.9 21.4-1.6 0 0-19.9 11.3-23.6 6.1-2.4 5-4.7 10.5-6.8 16.3 8.4-6.7 22.7-6.1 22.7-6.1-10.3 12.9-20.2 11.2-24 9.8-1.6 4.8-3.1 9.8-4.4 15 9.4-7.7 22.3-6.5 22.3-6.5-11.4 12.3-20.1 9.3-22.7 8-1.3 5.5-2.3 11.2-3.1 17.1 7.1-6.9 24-7.3 24-7.3-11.6 15.9-20.8 13.4-24.4 11.4-1 10.7-1 21.9.5 33.6.1.8-.5 1.6-1.3 1.7-.3 0-.6 0-.8-.1-.4-.2-.8-.6-.8-1.2-1.6-12.1-1.6-23.7-.5-34.6-8.2 4.8-21-12.4-21-12.4 9.7-.6 18.2 6.6 21.3 9.7.7-6 1.7-11.8 3-17.3-9.8 4.5-18.7-18.9-18.7-18.9z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.1 396.5c-.3 0-.5-.1-.8-.2-.5-.3-.9-.8-1-1.4-1.5-11.1-1.7-22.6-.5-34.2-3.4 1.7-8.1 0-13.5-4.7-4.2-3.7-7.4-8-7.5-8.1l-.3-.4h.5c9.4-.6 17.7 6.1 21.1 9.4.6-5.4 1.6-10.8 2.8-16.3-1.5.6-3 .5-4.6-.1-7.5-3-13.4-18.5-13.7-19.2l-.2-.5.5.1c9.8 2.6 16.3 11.3 18.9 15.5 1.2-4.8 2.6-9.7 4.3-14.5-8.4-1.3-11.9-7.1-13.5-11.8-1.7-5.1-1.3-10.1-1.3-10.1v-.4l.4.2c10 5.7 14.1 13.7 15.7 18.5 1.9-5.4 4.1-10.7 6.5-15.8.3-.6.6-1.2.8-1.8h-.1c-7.7 0-11.8-20.9-11.9-21.8l-.1-.7.5.4c8.4 5.9 12.1 13.6 13.6 18.2 2.5-4.9 5.2-9.7 8-14.3-11.1-9-4.2-24.4-4.1-24.5l.2-.4.3.3c6.5 7.2 7 15.2 6.6 20 4.3-6.6 7.8-10.9 8.8-12.2.9-12.3 12.9-20.7 13-20.8l.4-.3v.5c1.1 13.8-5.8 19.7-10.1 22.1-.1.1-.1.2-.2.3 0 0-4.2 5-9.7 13.6 4.1-3 11.5-6.8 21.4-4.6l.4.1-.2.3c-.1.1-10.4 14.1-24 8.2-2.5 4.2-4.9 8.5-7.2 12.9 3.7-1.6 10.8-3.5 20.9-1.3l.7.2-.6.4c-.8.5-19.3 10.9-23.7 6.4-2.3 4.9-4.4 10-6.3 15 8.4-6.1 22-5.7 22.1-5.6h.5l-.3.4c-10.2 12.7-20 11.3-24 10-1.6 4.6-2.9 9.3-4.1 14 9.4-7.1 21.8-6 21.9-6l.5.1-.4.4c-4.9 5.3-9.9 8.4-14.8 9.2-3.7.6-6.5-.3-7.9-1-1.2 5.3-2.2 10.7-2.9 16 7.3-6.4 22.9-6.8 23.6-6.8h.6l-.3.4c-3.9 5.3-14 17.1-24.4 11.7-1.1 11.2-.9 22.3.6 33.1.1 1-.6 1.9-1.5 2-.2-.1-.3-.1-.4-.1zm-1.6-36.7l-.1.5c-1.2 11.7-1 23.3.5 34.6.1.4.3.8.7 1 .2.1.5.1.7.1.7-.1 1.2-.7 1.1-1.4-1.4-11-1.6-22.3-.5-33.6v-.4l.4.2c9.9 5.5 19.7-5.4 23.8-10.9-3 .1-17.1 1.1-23.2 7.2l-.6.5.1-.8c.7-5.7 1.7-11.4 3.1-17.1l.1-.3.3.2c9.1 4.7 18.7-4 22-7.5-2.6-.1-13.4-.2-21.6 6.4l-.6.5.2-.8c1.2-5 2.7-10.1 4.4-15.1l.1-.3.3.1c3.7 1.3 13.3 3 23.4-9.3h-.1c-2.9 0-14.7.4-21.8 6.1l-.8.6.3-.9c2-5.5 4.3-11 6.8-16.3l.2-.4.3.4c3.1 4.4 19.2-4 22.6-5.9-10.2-2.1-17.2.2-20.5 1.8l-.7.3.4-.7c2.4-4.7 4.9-9.3 7.6-13.8l.1-.2.2.1c12.1 5.5 21.7-5.5 23.3-7.6-10.5-2.2-18.1 2.5-21.7 5.5l-1.3 1.1.9-1.4c6-9.5 10.6-14.9 10.6-15 .1-.1.1-.2.2-.3v-.1h.1c4.1-2.2 10.8-7.9 9.9-21.1-2.1 1.6-11.7 9.3-12.4 20.2v.1l-.1.1c-1 1.3-4.7 5.9-9.4 13.2l-.7 1 .2-1.2c.7-5.4.2-13.2-6.1-20.4-1 2.4-5.7 15.7 4.3 23.6l.2.2-.1.2c-3 4.9-5.8 9.9-8.4 15.1l-.3.6-.2-.6c-1.3-4.2-4.7-12.1-13-18.1.8 3.7 5 21.6 11.8 20.7l.5-.1-.2.5c-.3.7-.7 1.4-1 2.2-2.5 5.4-4.8 10.9-6.8 16.5l-.3.8-.2-.8c-1.3-4.5-5.1-12.8-15.3-18.7-.1 2.9.1 19 14.7 20.9h.3l-.1.3c-1.7 5.1-3.2 10.3-4.5 15.4l-.2.6-.3-.6c-2.3-3.8-8.7-12.7-18.4-15.6 1.1 2.7 6.6 15.7 13.2 18.3 1.6.6 3.2.6 4.6-.1l.5-.2-.1.5c-1.3 5.8-2.3 11.6-3 17.3l-.1.6-.4-.4c-3-3-10.8-9.7-19.9-9.7h-.7c2 2.6 13.1 16.2 20.4 11.9l.3-.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.497,
    y1: 340.64,
    x2: 108.979,
    y2: 340.64
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75e0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4add85"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.1 331.4c-9.1 4.6-14.3 13.9-16.2 17.9-1.7-4.3-3.6-8.3-5.6-12 14.9-5.7 11.8-21.8 11.8-21.8-9.3 7.6-12 15.8-12.8 19.8-2.6-4.6-5.2-8.8-7.8-12.4-.4-.5-.8-1.1-1.2-1.6 7.4-.9 9.3-21.1 9.3-21.1-7.7 7.3-10.2 15.3-10.9 19-3.2-4.2-6.3-7.8-9.2-10.8 9.6-10.2 1.7-21.6 1.7-21.6-5.6 8-5.1 15.1-4 19.2-5-5-8.8-8.1-10-9-1.9-10.3-13.8-14.5-13.8-14.5.3 11.9 7.3 15.2 11.3 16.2.1.1.1.2.2.2.1.1 4.8 3.6 11.1 10.2-3.7-1.7-11.4-4-21.2.6 0 0 10.8 9.6 22.8 1.2 2.6 2.8 5.4 6.1 8.3 9.9-3.5-.6-10.4-.8-19.9 3.6 0 0 19.5 5 22.4-.3 2.6 3.7 5.3 7.8 7.8 12.2-8.3-3.7-21.5.1-21.5.1 10.7 8.5 19.7 4.8 23.1 2.7 1.9 3.7 3.8 7.6 5.4 11.7-9.4-4.3-21.2-.3-21.2-.3 11.6 7.8 19.4 3.2 21.7 1.5 1.7 4.3 3.2 8.9 4.4 13.8-7.1-4.2-22.8-.6-22.8-.6 12.2 10.8 20.4 6.5 23.6 4 1.9 8.8 2.9 18.3 2.6 28.5 0 .7.6 1.2 1.4 1.1.3 0 .5-.1.8-.3.4-.3.7-.7.7-1.2.4-10.6-.7-20.4-2.7-29.4 8.1 2.2 18.3-15.4 18.3-15.4-9 1.7-16.2 9.8-18.8 13.2-1.2-4.9-2.7-9.6-4.3-14 9.2 1.6 15.2-20.3 15.2-20.3z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.8 399c-.4 0-.7-.1-1-.4-.3-.3-.4-.6-.4-1.1.3-9.4-.5-18.9-2.5-28-3.3 2.5-11.6 6.4-23.6-4.2l-.4-.3.5-.1c.6-.1 15.1-3.4 22.5.3-1.1-4.3-2.5-8.6-4.1-12.8-8.5 6.2-18.8.3-21.7-1.7l-.5-.3.5-.2c.1 0 11.5-3.8 20.8 0-1.5-3.7-3.2-7.3-5-10.8-3.6 2.1-12.6 5.5-23.1-2.9l-.4-.3.5-.1c.1 0 12.6-3.6 21-.4-2.2-3.8-4.6-7.6-7.2-11.2-3.6 4.8-21.7.3-22.4.1l-.7-.2.7-.3c9.1-4.2 15.8-4.2 19.4-3.7-2.4-3.2-5-6.2-7.7-9.1-12 8.2-22.9-1.3-23-1.4l-.3-.3.4-.2c8.9-4.1 16-2.7 20.1-1.1-5.9-6-10.1-9.2-10.2-9.2l-.2-.2c-4.2-1-11.1-4.5-11.4-16.4v-.4l.4.1c.1 0 12 4.3 14 14.6 1.1.9 4.6 3.7 9.2 8.3-.8-3.9-1.1-10.9 4.3-18.5l.2-.3.2.3c.1.1 7.9 11.6-1.5 21.8 3 3.2 5.9 6.6 8.6 10.2 1-4.2 3.6-11.6 10.9-18.5l.5-.5-.1.7c-.1.8-1.9 19.6-9.1 21.3.3.4.6.8.9 1.3 2.7 3.8 5.2 7.7 7.5 11.8 1-4.4 4-12.1 12.8-19.3l.4-.3.1.4c0 .2 3 16.2-11.7 22 1.9 3.7 3.7 7.4 5.2 11.2 2.1-4.1 7.3-13 16-17.4l.6-.3-.2.6c-.2.9-6 21.4-15.1 20.5 1.6 4.3 3 8.6 4 13 2.9-3.6 9.9-11.2 18.6-12.9l.6-.1-.3.5s-2.6 4.5-6.2 8.5c-4.6 5.3-8.6 7.7-12 7.1 2.1 9.5 3 19.3 2.6 29.1 0 .5-.3 1.1-.8 1.4-.3.2-.6.3-.9.4-.2-.1-.3-.1-.3-.1zm-3.6-30.4l.1.4c2.1 9.3 2.9 19 2.6 28.6 0 .3.1.5.3.6.2.2.5.3.8.2.2 0 .4-.1.6-.3.3-.2.6-.6.6-1 .3-9.9-.6-19.7-2.7-29.4l-.1-.4.4.1c7 1.9 15.9-11.8 17.7-14.7-8.7 1.9-15.5 9.7-18 13l-.3.4-.1-.5c-1.1-4.7-2.6-9.4-4.3-13.9l-.2-.4.5.1c8 1.4 13.7-15.9 14.8-19.5-8.7 4.7-13.7 13.7-15.5 17.4l-.3.6-.2-.6c-1.6-4-3.5-8-5.6-12l-.1-.3.3-.1c13.1-5 12-18.3 11.7-21-8.8 7.3-11.5 15.3-12.4 19.4l-.1.7-.4-.6c-2.4-4.3-5-8.4-7.8-12.4-.4-.5-.8-1.1-1.2-1.6l-.3-.4.5-.1c6.3-.8 8.6-16.5 9-20.1-7.1 7-9.5 14.4-10.3 18.3l-.1.6-.4-.5c-2.9-3.8-5.9-7.4-9.1-10.8l-.2-.2.2-.2c8.5-9 3.1-19 1.9-20.9-5.1 7.5-4.9 14.3-3.7 18.6l.3 1-.7-.7c-5-5.1-8.9-8.1-9.9-9l-.1-.1v-.1c-1.6-9-11.2-13.3-13.3-14.1.4 11.3 7.1 14.6 11.1 15.5h.1l.1.1.2.2s4.8 3.6 11.2 10.2l1 1.1-1.3-.6c-3.6-1.7-11.1-3.9-20.5.4 1.9 1.5 11.6 8.3 22.2.9l.2-.1.2.2c2.9 3.1 5.7 6.5 8.3 9.9l.4.5-.7-.1c-3.2-.5-9.9-.8-19 3.3 3.6.8 18.8 4.1 21.3-.3l.2-.4.3.4c2.8 3.9 5.5 8.1 7.8 12.2l.4.7-.8-.3c-7.2-3.2-18.3-.7-20.8-.1 10.4 8 19.1 4.3 22.3 2.4l.2-.1.1.3c2 3.8 3.9 7.8 5.4 11.7l.3.6-.6-.3c-8.1-3.7-18.1-1.2-20.5-.4 3.4 2.2 13 7.2 20.9 1.2l.3-.2.1.3c1.8 4.5 3.2 9.2 4.4 13.8l.2.6-.6-.3c-6.2-3.7-19.3-1.2-22.1-.7 4.3 3.7 14.3 10.5 22.9 3.6l-.1-.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.758,
    y1: 314.225,
    x2: 131.351,
    y2: 314.225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75e0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4add85"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.2 313.2c-12.6 3.6-21.1 14.6-24.3 19.3-1.4-6.3-3.1-12.2-4.9-17.7 20.3-3.3 19.3-25.9 19.3-25.9-13.4 7.5-18.5 17.8-20.3 22.9-2.4-7-5.1-13.4-7.7-19-.4-.8-.8-1.7-1.2-2.5 9.7.9 16-25.7 16-25.7-11.3 7.6-16 17.7-17.7 22.3-3.3-6.5-6.6-12.3-9.8-17.2 14.4-10.9 6.3-28.6 6.3-28.6-8.7 9.1-9.4 18.9-8.8 24.6-5.4-8.2-9.8-13.4-11.1-15-.5-14.4-15-23.5-15-23.5-1.9 16.1 6.5 22.6 11.5 25 .1.1.1.3.2.4.2.2 5.5 6.3 12.4 17-4.4-3.4-13.9-8.7-27.4-5.4 0 0 12.1 16 29.2 8.3 2.8 4.5 5.8 9.8 8.8 15.7-4.4-1.8-13.3-4.1-26.4-1 0 0 24.2 12.3 28.9 6.1 2.7 5.7 5.3 12 7.7 18.7-9.9-7.3-27.6-6-27.6-6 12.2 14.6 24.5 12.1 29.2 10.4 1.8 5.5 3.4 11.3 4.8 17.3-11.3-8.5-27.3-6.5-27.3-6.5 13.5 13.8 24.4 10 27.7 8.3 1.4 6.3 2.4 12.9 3.1 19.8-8.4-7.8-29.3-7.4-29.3-7.4 13.7 18 25.1 14.7 29.7 12.2.8 12.4.3 25.5-2.1 39.1-.2 1 .5 1.8 1.5 1.9.4 0 .7 0 1-.2.6-.3 1-.8 1.1-1.4 2.5-14.2 3-27.7 2.1-40.4 10 5.3 26.5-15.4 26.5-15.4-12-.3-22.7 8.5-26.8 12.3-.6-7-1.6-13.7-2.9-20 11.6 4.8 23.6-22.8 23.6-22.8z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.7 401.4h-.2c-.6-.1-1.1-.3-1.4-.8-.3-.4-.4-.9-.4-1.5 2.2-12.7 2.9-25.7 2.1-38.6-2.5 1.3-6.4 2.5-11.3 1.4-6.2-1.4-12.4-6-18.4-13.9l-.3-.4h.5c.8 0 20.3-.2 29 7-.6-6.2-1.6-12.5-2.9-18.7-1.8.9-5.3 2.1-9.9 1.6-6-.7-12-4.1-17.8-10.1l-.4-.4.5-.1c.2 0 15.7-1.8 26.9 6.2-1.2-5.5-2.8-11-4.5-16.3-5 1.7-17.2 3.8-29.3-10.6l-.3-.4h.5c.2 0 17.1-1.1 27.3 5.7-2.1-5.9-4.5-11.8-7.2-17.5-5.4 5.6-28-5.9-29-6.4l-.7-.3.7-.2c12.6-3 21.4-1 25.9.7-2.6-5-5.4-10-8.4-14.8-17 7.5-29.2-8.3-29.3-8.5l-.2-.3.4-.1c12.4-3 21.6 1.2 26.4 4.6-6.5-10-11.5-15.6-11.6-15.7-.1-.1-.2-.2-.2-.3-5.2-2.5-13.4-9.2-11.5-25.3l.1-.4.4.2c.1.1 14.6 9.3 15.2 23.6 1.3 1.5 5.3 6.4 10.5 14.1-.4-5.5.6-15 9-23.8l.3-.3.2.4c.1.2 7.9 17.8-6.2 28.7 3.3 5.3 6.5 10.8 9.4 16.5 2-5.3 6.8-14.6 17.6-21.9l.6-.4-.2.7c-.3 1.1-6.2 25.9-15.8 25.9.3.7.7 1.4 1 2.1 2.8 5.9 5.3 12.1 7.4 18.3 2.1-5.6 7.4-15.2 20.2-22.4l.4-.2v.4c0 .1.2 5.8-2.1 11.8-2.1 5.5-6.8 12.5-17.2 14.3 1.8 5.6 3.4 11.2 4.7 16.9 3.4-4.9 11.8-15.4 24.1-18.9l.6-.2-.2.5c-.5 1.1-11.9 27.2-23.4 23.1 1.3 6.3 2.2 12.7 2.8 19 4.3-3.9 14.5-12 25.9-12h1.1l-.3.4c0 .1-4.2 5.2-9.6 9.7-7 5.9-12.7 7.8-16.9 6 .9 13.5.2 26.9-2.1 40-.1.7-.6 1.3-1.3 1.6-.5.2-.8.3-1.2.3zm.7-41.8v.4c.9 13.2.2 26.3-2.1 39.2-.1.4 0 .8.2 1 .2.3.6.5 1 .6.3 0 .6 0 .9-.2.5-.2.9-.7.9-1.2 2.3-13.2 3-26.7 2.1-40.3v-.5l.4.2c8.9 4.7 23.4-11.9 25.8-14.9-11.6 0-22 8.5-26 12.2l-.4.4v-.6c-.6-6.6-1.6-13.4-2.9-20l-.1-.5.5.2c3.2 1.3 8.5.8 15.8-9.5 3.7-5.2 6.4-10.9 7.2-12.7-12.2 3.8-20.5 14.5-23.6 19.1l-.4.5-.1-.6c-1.3-5.9-3-11.9-4.9-17.7l-.1-.3.3-.1c8.3-1.3 14.1-6 17.1-14 1.9-5 2-9.7 2-11.2-12.9 7.3-17.9 17.3-19.8 22.6l-.3.7-.3-.7c-2.2-6.4-4.8-12.8-7.7-18.9-.4-.8-.8-1.7-1.2-2.5l-.2-.4h1c8.3 0 14-20.7 15.1-24.8-10.6 7.4-15.2 16.8-17 21.8l-.2.6-.3-.6c-3-5.9-6.3-11.7-9.7-17.2l-.1-.2.2-.2c12.9-9.8 7.4-25.3 6.4-27.9-8.1 8.7-9.1 17.9-8.5 24.1l.1 1.1-.5-.6c-5.5-8.3-9.9-13.5-11.1-15l-.1-.1v-.1c-.4-12.8-12.3-21.5-14.6-23.1-1.7 15.5 6.4 21.9 11.4 24.3h.1v.1c.1.1.1.2.2.3.1.1 5.5 6.2 12.5 17l.8 1.3-1.2-1c-4.4-3.4-13.7-8.5-26.8-5.5 1.9 2.2 13.2 14.8 28.6 7.9l.2-.1.1.2c3.2 5.1 6.1 10.4 8.8 15.7l.3.7-.7-.3c-4.1-1.7-12.7-4-25.5-1.1 3.9 1.9 23.8 11.3 27.9 5.9l.3-.4.2.4c2.9 6.1 5.5 12.4 7.7 18.7l.3.8-.7-.5c-8.9-6.6-24-6.3-27.1-6.1 11.9 13.9 23.9 11.6 28.6 9.9l.3-.1.1.3c1.9 5.7 3.5 11.5 4.8 17.4l.2.7-.6-.4c-9.9-7.5-23.6-6.8-26.6-6.6 3.9 3.8 15.5 13.8 27 7.8l.3-.2.1.3c1.4 6.6 2.4 13.2 3.1 19.8l.1.7-.5-.5c-7.5-6.9-25.2-7.3-28.6-7.4 4.8 6.2 16.5 18.6 29 11.7l.5.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.508,
    y1: 400.14,
    x2: 130.619,
    y2: 400.14
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e036b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08003c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.6 381.3h11.1v9.5c0 15.5-10.1 28.1-22.4 28.1H92.9c-3.5 0-6.7-1-9.7-2.8-7.5-4.5-12.8-14.2-12.8-25.4v-9.5h49.2z",
    fill: "url(#SVGID_5_)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Chair_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234.3 418.5h-6.4l8.5-124.5h11.4zM350.7 418h6.4l-8.5-124.4h-11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.6 284.4h-81.8c-7.2 0-13.1-5.9-13.1-13.1l-7.6-115c0-7.2 5.9-13.1 13.1-13.1h97.1c7.2 0 13.1 5.9 13.1 13.1l-7.6 115c-.2 7.2-6.1 13.1-13.2 13.1z",
    fill: "#ee8d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2 301.5H227.4c-2.6 0-4.8-2.1-4.8-4.8v-16.9c0-2.6 2.1-4.8 4.8-4.8h130.9c2.6 0 4.8 2.1 4.8 4.8v16.9c-.1 2.6-2.2 4.8-4.9 4.8z",
    fill: "#ffa82f"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_3_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.1 130.1c4.7-14.1-2.9-29-4.7-35.8-3.5-13.5-28.2-22.3-39.4-15.9-3.8 2.2-5.9 4.2-6.3 5.4-3.1-.7-6 3.4-8.4 8.7-2.8 6.3-2.3 17.6-4.7 25.3-2.3 7.5-3.2 14.5 0 17.6 3.3 3.2 56.6 15.4 63.5-5.3z",
    fill: "#490d0d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.6 148.9c2.1 0 11.8 5.3 24.7 59.9 0 0-12.9 20.6-21.2 12.3 0 .1-14.4-66.9-3.5-72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M292.2 147.7s-1.3-1.3-1.6-5.4c-.1-1.3-.2-2.9 0-4.8 0 0-9.3-14.8-18.5-12.3 0 0 .2 1.6.2 4 .1 4.5-.3 11.7-3 15.6.2.4.8 9.2 1.2 10 13.5 4.7 25.2 1.8 26.4 0 0-.4-4.2-5.3-4.7-7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M295.1 184.7c-17-7.1-23.5-21.2-24.7-30 13.5 4.7 25.2 1.8 26.4 0 10.1 15.9-1.7 30-1.7 30z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.606,
    y1: 202.554,
    x2: 257.931,
    y2: 236.686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebeeff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.7 248.8s-21.2 18.8-67-1.8c0 0 8-26.2 5.5-33.6-3.7-11.1-7.6-24.9-9-26.3 0 0-2.4-27 1.2-38.8 0 0 8.6 1.2 16.5-.4 1-.2 2-.4 2.9-.7 1.6-.5 2.4-1.6 3.5-2.4.2.4.6 3.2 2.9 7.8.5.9 6.6 9.5 16.1 7.9 7.5-1.3 7.1-8.5 5.4-12.5 0 0 .7.3 4.6.7 3.3.3 7.8 1.1 13.5.9 0 0 1.8 20 2.9 27 1.2 7.1 5.3 12.3 5.3 18.8s-6.1 29.9-4.3 53.4z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M283.5 263.9c-.1.7-.7 1.3-1.4 1.4l-33.6-.2c-.9.1-1.4-.6-1.7-1.5-4.6-15.4 1.9-16.6 5.4-34.2.6-3.1.9-6.8.5-10.8-.1-1.6-.3-3.1-.4-4.5-1.3-11.2-3.6-16.5-3.6-16.5.6-1.8-2.4-49.4-2.4-49.4 18.2 1.8 22.9-3.5 22.9-3.5s18.2 38.8 21.2 50c2.8 10.3-5.9 59.4-6.9 69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M290.6 142.3c-9.2-1.3-15.1-8-18.3-13.1 0-2.4-.2-4-.2-4 9.2-2.6 18.5 12.3 18.5 12.3-.2 1.9-.2 3.5 0 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M269.3 143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M292.2 137.3c-8.1 2.3-18.4-8.1-20.1-10.4-1.7-2.3-2.3-7.5-2.3-7.5-2.3 2.3-6.9.6-8.1-4-1.1-4.3 1.9-6.6 4.2-5.9.2 0 .3.1.4.2 2.3 1.2 2.9 0 3.5-5.8.6-5.8 3.5-9.2 3.5-9.2s6.9 6.9 15.5 4.6c8.6-2.3 13.8 1.7 13.2 5.2-.1.8-.2 1.6-.2 2.3-.1 2.1.4 3.7.8 6.4.5 3.4-2.4 21.8-10.4 24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M302 104.5c-.1.8-.2 1.6-.2 2.3-3.1-7.3-11.4-4.6-16.4-4.6-5.2 0-11.5-5.2-11.5-5.2-2.3 2.9-2.9 10.4-4 12.7-1.1 2.2-3.7 0-3.9-.2.2 0 .3.1.4.2 2.3 1.2 2.9 0 3.5-5.8.6-5.8 3.5-9.2 3.5-9.2s6.9 6.9 15.5 4.6c8.5-2.3 13.6 1.7 13.1 5.2zM268 115.9c-.1 0-.3-.1-.3-.2 0 0-.6-2.9-2.2-3.7-.6-.3-1.3-.3-2 .1-.1.1-.3 0-.4-.1-.1-.1 0-.3.1-.4.9-.5 1.8-.5 2.6-.1 1.9.9 2.4 4 2.5 4.1 0 .1-.1.2-.3.3.1 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M265.6 115.9c-.2 0-.3-.1-.3-.3 0-.1.1-2 .6-3 .1-.1.3-.2.4-.1.1.1.2.3.1.4-.5.9-.6 2.7-.6 2.8.1 0 0 .2-.2.2zM274 96.5c-.1 0-.2 0-.3-.1-3.6-3-4.8-5.3-4.8-5.4-.1-.2 0-.5.2-.7.2-.1.5 0 .7.2 0 0 1.2 2.3 4.6 5.1.2.2.2.5.1.7-.2.1-.4.2-.5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M292.2 147.7s12.3 1.8 19.4 1.2c0 0 2.4 24.7 5.3 32.3 2.9 7.6 6.1 10.4 2.5 26.7-3.3 14.6 3 54.4 4.3 62.4.1.8-.4 1.6-1.2 1.9l-13.4 4.2c-1.1.3-2.2-.5-2.2-1.6.2-11.7 1.2-64.6 1.7-77.6.6-14.8-16.4-49.5-16.4-49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M286.6 207.2c0 1.3-1.1 2.4-2.4 2.4s-2.4-1.1-2.4-2.4 1.1-2.4 2.4-2.4 2.4 1.1 2.4 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M284.3 211c-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.8 3.8zm0-7c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2c1.8 0 3.2-1.4 3.2-3.2s-1.4-3.2-3.2-3.2zM280.5 247.7c0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4c1.3.1 2.4 1.1 2.4 2.4zM287.5 251.6c-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8 0 2-1.7 3.8-3.8 3.8zm0-7.1c-1.8 0-3.2 1.4-3.2 3.2 0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.5 3.2-3.2 0-1.7-1.4-3.2-3.2-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M308.1 194.7c-.3 0-.6-.2-.6-.6 0-.9-1.1-20.7 2.7-25.9l-8.7-8.7 2.3-4.6-8.4-5.6c-.3-.2-.3-.5-.2-.8.2-.3.5-.3.8-.2l9.2 6.2-2.4 4.8 8.9 8.9-.4.4c-3.2 3.2-3.1 19.4-2.8 25.4.2.4-.1.7-.4.7zM291.6 198.2c-.2 0-.4-.1-.5-.3-7.5-14.9-26.6-25.5-26.8-25.6l-.5-.3 7-11.6-8.7-2.9 3.1-8.8c.1-.3.4-.5.8-.4.3.1.5.4.4.8l-2.7 7.7 8.9 3-7.1 11.9c3.2 1.8 19.8 12 26.7 25.8.1.3 0 .6-.3.8-.1-.1-.2-.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M286.6 213.4s17.4-6.1 20.2-4.8c2.9 1.2 14.7 11.7 14.7 11.7s-.8 4.4-4.3 4.8c-3.5.4-11-4.4-12.8-3.9-1.8.5-6.8 2.8-13.2 1.9-4.8-.6-6.2-1.5-6.2-1.5s-1.1-6.9 1.6-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M320.6 222.5c-.1 0-.2 0-.2-.1 0 0-1-1-7.6-6.7-6.5-5.5-8.8-4.3-8.9-4.3-.1.1-.3 0-.4-.1-.1-.1 0-.3.1-.4.1-.1 2.7-1.6 9.5 4.3 6.7 5.8 7.6 6.7 7.7 6.7.1.1.1.3 0 .4 0 .2-.1.2-.2.2zM318.1 224.9c-.1 0-.2 0-.2-.1 0 0-3.7-4.1-8.1-7-4.3-2.8-6.1-1.9-6.1-1.9-.1.1-.3 0-.4-.1-.1-.1 0-.3.1-.4.1 0 2-1.1 6.7 2 4.5 2.9 8.2 7 8.2 7.1.1.1.1.3 0 .4h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M252.4 214.1c-1.3-11.2-3.6-16.5-3.6-16.5 1.2-5.3 6.5-8.8 6.5-8.8 1.5 6.2 1.6 19.4-2.9 25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M248.7 197.7s-2.4 9.4-1.8 10.6c.6 1.2-2.4 2.9-2.4 2.9-10 3.5-14.7 17-14.7 17-5.3 0-5.6-.1-8.1-.9-2.2-.6-3.6-2.8-3.3-5 .4-2.8-1.5-2.4-1-5.3.3-1.6 3.6-12.9 4-14.5 6.5-27.8 21-54.3 24.8-54.3 15.4 21.8 2.5 49.5 2.5 49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M286.6 213.4s-28.8-1.3-34.6-1.6c0 0-17.1 1-14.9 16.4 0 0 18.3-.3 29.6-3.4 11.3-3 18.4-3.3 18.4-3.3s3-2.1 1.5-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.9 211.8l-7.3-.7s-17.5 1.6-14.7 17c0 0 4.2.5 7.2 0-.4-4.6 5.9-13.1 14.8-16.3z",
    fill: "#ebeeff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M396.2 346.5l14.7 16.5 3.5-2.4s-13.5-14.7-18.2-14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M408.3 351.6c-.6 1.9-1.5 3.3-3.1 2-3.4-2.8-7.8-5.4-10.2-7.2-2.4-1.8-2-7.1-2-7.1 4.4-.5 13.8 10.1 15.3 12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M402.2 350.5s10.4 12.2 14.4 13.4c5.8 1.8 19.4-7.5 17-12.7-1-2.2-3.9-4.8-7-7 2.6 2.2 5 3.9 5.9 5.9 2.3 5-11 14.1-16.6 12.4-3.1-1.6-11.9-10.4-13.7-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M402.2 350.5s10.2 11.1 13.6 12.1c5.6 1.7 18.9-7.4 16.6-12.4-.9-2-3-3.7-5.9-5.9-3.3-2.5-5.1-3.7-5.1-3.7s-19.3-2.5-19.2 9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M420.7 351c-4.5 2.5-8.6 1.9-12.4.7-3.3-1.1-8.5-8.7-15.3-12.3-2.5-1.3-3.5-3.5-4.3-5.8-3.1-8.9-7.5-9.6-28.3-32.7 4.6-8.3 8.9-10.4 15.4-11.9 4.6 3.6 21.3 25.9 24.9 30 6.1 7.2 14.6 17.8 20.9 21.6 3.3 2.1 6 6.5-.9 10.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.189,
    y1: 259.721,
    x2: 346.519,
    y2: 282.573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e036b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08003c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320.8 263.7c4.8 6.7 34 39.7 56.4 62.3l20.1-17.2S347 247.7 339 237.5c-8-10.2-37-.3-18.2 26.2z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.466,
    y1: 305.935,
    x2: 300.424,
    y2: 289.095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e036b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08003c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 274.8s29.4 0 37 8.8 32.9-26.4-7.1-32.9c-39.9-6.5-29.9 24.1-29.9 24.1z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.88,
    y1: 229.817,
    x2: 296.005,
    y2: 267.848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e036b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08003c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.4 243.6c-4.4 2.7-10.6 7.1-9.4 18.8 3.8 37.8 85.2-4.1 86.4-2.9 1.2 1.2 3.5-24 3.5-24s-58.4-5.7-80.5 8.1z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M305.6 418.7h21.6s.9-1.2 1.2-2.4c-2.1 0-6.9-.5-12-.5-4.2 0-8.7.6-12 .5.1 1.3 1.2 2.4 1.2 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M308.5 385.4s-4.1 16.1-4.1 30.9h24s.9-7-1.2-16.4c-.7-5.1-13.7-17.3-18.7-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M309 354.9s-.4 23.8-.4 29.3-2.8 20.3-.9 22.1c1.8 1.8 17.5 1.8 19.3-.9 1.8-2.8-2.6-16.3-1.8-24.9.3-2.9 1-4.6 1-5.9 0-2.6-1-4.2-1-9.7v-10.2l-16.2.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.901,
    y1: 907.716,
    x2: 76.455,
    y2: 912.924,
    gradientTransform: "rotate(11.536 3207.202 1673.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e036b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08003c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.9 269.7c-.5 8.2-1.2 55.1 2.1 86.8h27s2-79.7 2.2-92.6c.2-13-29.3-26.6-31.3 5.8z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M330.3 349H304c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h26.3c.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM371.3 320c-.2 0-.4-.1-.5-.2-.2-.3-.2-.7 0-.9l19.3-17.8c.3-.2.7-.2.9 0 .2.3.2.7 0 .9l-19.3 17.8c-.1.1-.2.2-.4.2z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lamp_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M445.4 225.1c-.4 0-.9-.1-1.3-.4-1.2-.7-1.6-2.3-.9-3.5L486 149l-37.6-11.1c-1.4-.4-2.2-1.8-1.7-3.2.4-1.4 1.8-2.2 3.2-1.7l44 13-46.2 77.9c-.6.7-1.4 1.2-2.3 1.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 490.1,
    cy: 147.6,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M445.7 137.2H433c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6h12.6c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.5 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M460.8 227.5H422c0-3.2 2.6-5.7 5.7-5.7H455c3.2 0 5.8 2.6 5.8 5.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.733,
    y1: 133.418,
    x2: 436.505,
    y2: 133.418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebeeff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.3 143c-3.2-2.9-3.4-7.9-.5-11.1l7-7.6c2.9-3.2 7.9-3.4 11.1-.5 3.2 2.9 3.4 7.9.5 11.1l-7 7.6c-2.9 3.3-7.9 3.5-11.1.5z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M444.2 139.7v-8.6c0-.8.8-1.2 1.5-.9l7.4 4.3c.7.4.7 1.3 0 1.7l-7.4 4.3c-.7.5-1.5 0-1.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.7 148.9l8.9 6.7-.6.7c-1.8 2.4-5.3 2.9-7.8 1.1-2.4-1.8-2.9-5.3-1.1-7.8l.6-.7z",
    fill: "#ffba2a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.734,
    y1: 148.296,
    x2: 430.472,
    y2: 148.296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebeeff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.3 166l-32.5-24.6 2.1-2.8c6.8-9 19.6-10.7 28.6-4 9 6.8 10.7 19.6 4 28.6l-2.2 2.8z",
    fill: "url(#SVGID_12_)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Cup_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M185.4 222.1c-.9 0-1.7-.1-2.2-.3-2.2-.8-2-6.9-2-7 .1-3.1 1-5 2.6-5.4 3.1-.8 6.9 1.4 7.1 1.5l.5.3v8.4l-.2.3c-1 1.6-3.7 2.2-5.8 2.2zm-1.4-2.3c1.2.3 4.2 0 5.2-.8v-6.4c-1.2-.6-3.3-1.4-4.9-1-.2 0-.4.3-.6 1-.7 2.3-.2 6.3.3 7.2zm.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3 199.7c1.1-1.3 2.4-2.5 3.3-3.9.9-1.4 1.5-3.3.8-4.8-.7-1.9-2.8-2.8-4.7-3.4-1.9-.6-4-1.2-5.2-2.8-1.4-1.8-1.2-4.3-1.2-6.5 0-2.3-.4-4.9-2.3-6-1.4-.8-4.3-.6-5.6.3s-2.3 2.4-2.9 3.9c-1.3 3.4-1.3 8 1.2 10.6 2 2 4.7 2.9 4.9 5.5.2 2.3-2.8 6.3-2 8.4 1.2 3 5.5 3.8 6.5 6.9.3.9.3 1.8.4 2.7.1.9.4 1.8 1.1 2.4 1 .8 2.3.4 2.3-.8.1-1.5-.2-2.9 0-4.3.4-3.1 1.5-5.9 3.4-8.2z",
    opacity: 0.55,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M203.4 207.2l-.2 14.8c0 2.8-2.2 5.1-5 5.4-.8.1-1.8.1-2.9.1-1.1 0-2.1 0-2.9-.1-2.8-.3-5-2.6-5-5.4v-2.2l-.1-7.9v-4.6c3.8 0 12.4 0 16.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M201.7 225.2h-12.8c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h12.8c.1 0 .2.1.2.2s-.1.2-.2.2zM187.3 211.8c-.1 0-.2-.1-.2-.2v-1.9c0-.1.1-.2.2-.2s.2.1.2.2v1.9c0 .1-.1.2-.2.2zM187.4 221.8c-.1 0-.2-.1-.2-.2V220c0-.1.1-.2.2-.2s.2.1.2.2v1.6c0 .1-.1.2-.2.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Laptop_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M337.7 173h63.8c1.9 0 3.2 1.9 2.6 3.7l-19.3 50.4h-69l17.9-51.1c.4-1.8 2.1-3 4-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M318.4 227.1h-34.6c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h34.6c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M385.5 224.7l-.9 2.3h-69l.9-2.3z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Table_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M464.1 418.7h6.4l-12.9-184.5h-12.9zM172.6 418.7h-6.4l12.9-184.5H192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M479.1 235.9H156.7c-1.4 0-2.6-1.2-2.6-2.6v-3.6c0-1.4 1.2-2.6 2.6-2.6h322.4c1.4 0 2.6 1.2 2.6 2.6v3.6c0 1.4-1.2 2.6-2.6 2.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M366.7 209.7l-15.7-.1c-1 0-1.5-.8-1.2-1.7l5.3-15.2c.3-.9 1.4-1.7 2.4-1.7l15.7.1c1 0 1.5.8 1.2 1.7l-5.3 15.2c-.4 1-1.4 1.7-2.4 1.7z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -770.622,
    y1: 200.359,
    x2: -763.387,
    y2: 200.359,
    gradientTransform: "matrix(1 0 -.3502 1 1195.133 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebeeff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.2 203.6l1.7-1.4c.6.7 1.3 1.1 2.3 1.1.8 0 1.4-.3 1.6-.9.2-.5 0-.8-1.4-1.2-1.7-.5-2.7-1-2.1-2.8.6-1.7 2.3-2.8 4.2-2.8 1.3 0 2.3.4 3 1.2l-1.6 1.5c-.6-.6-1.3-.9-2.1-.9s-1.3.4-1.5.8c-.2.6.1.8 1.6 1.2 1.7.5 2.5 1.1 1.9 2.7-.6 1.8-2.4 2.8-4.3 2.8-1.3.2-2.5-.3-3.3-1.3",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -762.798,
    y1: 200.36,
    x2: -755.223,
    y2: 200.36,
    gradientTransform: "matrix(1 0 -.3502 1 1195.133 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebeeff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M365.9 197.6h-2.8l.7-1.8h7.6l-.7 1.8h-2.8l-2.5 7.3h-2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M291.6 122.8c-.3 0-.5-.1-.7-.3-.3-.3-.2-.8.1-1.1.3-.2.6-.4 1-.6.5-.3.9-.5 1.2-.9 0-.2-.1-.5-.2-.9-.4-1.4-1.1-3.6-.5-6.7.2-1.3.5-2.6 1.8-3.5 1.2-.8 2.7-1.2 4.2-1.1.4 0 .8.4.7.8 0 .4-.4.8-.8.7-1.1-.1-2.3.2-3.2.8-.7.5-.9 1.2-1.2 2.4-.4 2.7.1 4.6.5 6 .2.8.4 1.3.3 1.8 0 .1 0 .1-.1.2-.4.8-1.2 1.2-1.9 1.6-.3.2-.6.3-.8.5-.1.2-.2.3-.4.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M285.3 113.4c-1 .1-2-.1-2.8-.7-.4-.3-.4-.7-.2-1.1.3-.4.8-.4 1.1-.2.7.5 1.8.6 2.6.2.4-.2.9-.1 1.1.3.2.4.1.9-.3 1.1-.5.2-1 .4-1.5.4zM297.6 113.3c-.7.1-1.4-.1-2-.5-.4-.3-.4-.7-.2-1.1.3-.4.7-.4 1.1-.2.5.3 1.2.3 1.6-.1.3-.3.8-.3 1.1.1.3.3.3.8-.1 1.1-.3.4-.9.6-1.5.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M286.6 109.7c-.2 0-.3 0-.5-.1-1.1-.7-2.6-.7-3.8-.1-.4.2-.9.1-1.1-.3-.2-.4-.1-.9.3-1.1 1.6-.9 3.7-.8 5.3.1.4.2.5.7.3 1.1-.1.3-.3.4-.5.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoS1);
export default __webpack_public_path__ + "static/media/logo-s1.a747a37cd72590bb68c8b439ed4d6913.svg";
export { ForwardRef as ReactComponent };